//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElSlider from '@/components/common/Slider'
import scroll from '@/mixins/scroll'

export default {
  name: 'GallerySection',
  components: {
    ElSlider,
  },
  mixins: [scroll],
  data() {
    return {
      options: {
        slidesPerView: 1,
        loop: true,
        duration: 1000,
        dragStart: () => {
          this.setPause(true)
        },
        dragEnd: () => {
          this.setPause(false)
        },
      },
      current: 1,
      sliderSize: 0,
      pause: false,
      interval: null,
      showSlider: false,
      gallery: [
        'img1.png',
        'img1.png',
        'img1.png',
        'img1.png',
        'img1.png',
        'img1.png',
      ],
      defaultPaths: {
        img1: require('~/assets/img/partner/main/gallery-section/img1.png'),
        img2: require('~/assets/img/partner/main/gallery-section/img2.png'),
        img3: require('~/assets/img/partner/main/gallery-section/img3.png'),
        img4: require('~/assets/img/partner/main/gallery-section/img4.png'),
        img5: require('~/assets/img/partner/main/gallery-section/img5.png'),
        img6: require('~/assets/img/partner/main/gallery-section/img6.png'),
        img7: require('~/assets/img/partner/main/gallery-section/img7.png'),
        img8: require('~/assets/img/partner/main/gallery-section/img8.png'),
        img9: require('~/assets/img/partner/main/gallery-section/img9.png'),
        img10: require('~/assets/img/partner/main/gallery-section/img10.png'),
      },
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize, true)
    this.resize()
  },
  methods: {
    imageSrc(key, defaultPath) {
      const alternativeImg = this.$getBullets(key)
      if (alternativeImg[0]) {
        return alternativeImg[0].url
      }

      return this.defaultPaths[defaultPath]
    },
    async resize() {
      if (window.innerWidth < 640) {
        if (this.showSlider === false) {
          this.showSlider = true
          await this.$nextTick()
          this.options.slideChanged = (s) => {
            this.current = s.details().relativeSlide
          }
          this.$refs.slider.$forceUpdate()
          this.$refs.slider.slider.refresh(this.options)
          this.sliderSize = this.$refs.slider.slider.details().size
          this.setInterval()
        }
      } else {
        this.resetInterval()
        this.showSlider = false
      }
    },
    setPause(active) {
      this.pause = active
      this.setInterval()
    },
    resetInterval() {
      clearInterval(this.interval)
    },
    setInterval() {
      if (this.$refs.slider) {
        this.resetInterval()
        this.interval = setInterval(() => {
          if (!this.pause) {
            this.$refs.slider.slider.next()
          }
        }, 3000)
      }
    },
  },
}
